import { Node, mergeAttributes } from "@tiptap/core";
import { ReactNodeViewRenderer } from "@tiptap/react";
import { TheoremNodeView } from "@/components/editor/nodeviews/TheoremNodeView";

export const TheoremBlock = Node.create({
  name: "theoremBlock",
  group: "block",
  atom: true,

  addAttributes() {
    return {
      blockId: { default: null },
      theoremType: { default: "theorem" },
      title: { default: "" },
      text: { default: "" },
      label: { default: "" },
    };
  },

  parseHTML() {
    return [{ tag: 'div[data-type="theorem-block"]' }];
  },

  renderHTML({ HTMLAttributes }) {
    return ["div", mergeAttributes(HTMLAttributes, { "data-type": "theorem-block" })];
  },

  addNodeView() {
    return ReactNodeViewRenderer(TheoremNodeView);
  },
});
